module.exports = require 'views/core/CreateAccountModal/CreateAccountModal'



// WEBPACK FOOTER //
// ./app/views/core/CreateAccountModal/index.coffee